// import React, { useEffect, useState } from 'react';
// //import io from 'socket.io-client';
// import { turnConfig } from '../../components/TurnServerConfig';

const LiveCourseArena = () => {
  
};

export default LiveCourseArena;
